// extracted by mini-css-extract-plugin
export default {"invalid-error":"MultipleCorpChoice_invalid-error__U2LAM"};